import React from 'react';
import { useTranslation } from 'react-i18next';

function SystemAclRoleForm({
  form,
  formErrors,
  permissionGroups,
  isSaving,
  isEditing,
  onFormChange,
  onTogglePermissionKey,
  onCancel,
  onSubmit,
}) {
  const { t } = useTranslation();

  return (
    <form onSubmit={onSubmit}>
      <div className="card card-body">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">{t('systemAcl.nameLabel')}</label>
            <input
              className={`form-control ${formErrors.name ? 'is-invalid' : ''}`}
              value={form.name}
              onChange={(event) => onFormChange('name', event.target.value)}
              required
            />
            {formErrors.name ? <div className="invalid-feedback">{formErrors.name}</div> : null}
          </div>
          <div className="col-md-6">
            <label className="form-label">{t('systemAcl.slugLabel')}</label>
            <input
              className={`form-control ${formErrors.slug ? 'is-invalid' : ''}`}
              value={form.slug}
              onChange={(event) => onFormChange('slug', event.target.value)}
              disabled={isEditing}
              required
            />
            {formErrors.slug ? <div className="invalid-feedback">{formErrors.slug}</div> : null}
          </div>
          <div className="col-12">
            <label className="form-label">{t('systemAcl.descriptionLabel')}</label>
            <textarea
              className="form-control"
              rows="3"
              value={form.description}
              onChange={(event) => onFormChange('description', event.target.value)}
            />
          </div>
        </div>

        <div className="mt-4">
          <h6 className="mb-3">{t('systemAcl.permissionsLabel')}</h6>
          <div className="row g-3">
            {permissionGroups.map((group) => (
              <div key={group.group} className="col-md-6">
                <div className="border rounded p-3 h-100">
                  <div className="fw-semibold text-capitalize mb-2">{group.group}</div>
                  <div className="d-flex flex-column gap-2">
                    {group.permissions.map((permission) => (
                      <label key={permission.key} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={form.permissionKeys.includes(permission.key)}
                          onChange={() => onTogglePermissionKey(permission.key)}
                        />
                        <span className="form-check-label">
                          <span className="d-block">{permission.key}</span>
                          {permission.description ? (
                            <span className="text-muted small">{permission.description}</span>
                          ) : null}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <button type="button" className="btn btn-default" onClick={onCancel} disabled={isSaving}>
          {t('common.cancel')}
        </button>
        <button type="submit" className="btn btn-theme" disabled={isSaving}>
          {isEditing ? t('systemAcl.saveRole') : t('systemAcl.createRole')}
        </button>
      </div>
    </form>
  );
}

export default SystemAclRoleForm;
